import type { Template } from "@/types";

export const PO_04_H3_V1: Template[] = [
    {
        id: "po-04-h3v1-01",
        name: "PO 01 - H3V1",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-04-h3_v1_01.png",
        size: [1298, 827],
        style: {},
        slots: [
            { id: "1", x: 100, y: 90, width: 452, height: 646, rotation: 0, imageRotation: 0 },
            { id: "2", x: 829, y: 0, width: 408, height: 271, rotation: 0, imageRotation: 0 },
            { id: "3", x: 829, y: 279, width: 408, height: 270, rotation: 0, imageRotation: 0 },
            { id: "4", x: 829, y: 557, width: 408, height: 270, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-04-h3v1-02",
        name: "PO 02 - H3V1",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-04-h3_v1_02.png",
        size: [1298, 827],
        style: {},
        slots: [
            { id: "1", x: 58, y: 59, width: 496, height: 710, rotation: 0, imageRotation: 0 },
            { id: "2", x: 872, y: 59, width: 368, height: 232, rotation: 0, imageRotation: 0 },
            { id: "3", x: 872, y: 299, width: 368, height: 231, rotation: 0, imageRotation: 0 },
            { id: "4", x: 872, y: 538, width: 368, height: 231, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-04-h3v1-03",
        name: "PO 03 - H3V1",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-04-h3_v1_03.png",
        size: [1298, 827],
        style: {},
        slots: [         
            { id: "1", x: 122, y: 59, width: 368, height: 232, rotation: 0, imageRotation: 0 },
            { id: "2", x: 122, y: 299, width: 368, height: 231, rotation: 0, imageRotation: 0 },
            { id: "3", x: 122, y: 538, width: 368, height: 231, rotation: 0, imageRotation: 0 },
            { id: "4", x: 725, y: 59, width: 496, height: 710, rotation: 0, imageRotation: 0 },
        ],
    },

    {
        id: "po-04-h3v1-04",
        name: "PO 04 - H3V1",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-04-h3_v1_04.png",
        size: [1298, 827],
        style: {},
        slots: [
            { id: "1", x: 83, y: 185, width: 483, height: 290, rotation: 0, imageRotation: 0 },         
            { id: "2", x: 83, y: 483, width: 238, height: 158, rotation: 0, imageRotation: 0 },
            { id: "3", x: 329, y: 483, width: 237, height: 158, rotation: 0, imageRotation: 0 },
            { id: "4", x: 725, y: 59, width: 496, height: 710, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-04-h3v1-05",
        name: "PO 05 - H3V1",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-04-h3_v1_05.png",
        size: [1298, 827],
        style: {},
        slots: [
            { id: "1", x: 83, y: 352, width: 483, height: 290, rotation: 0, imageRotation: 0 },
            { id: "2", x: 83, y: 186, width: 238, height: 158, rotation: 0, imageRotation: 0 },
            { id: "3", x: 329, y: 186, width: 237, height: 158, rotation: 0, imageRotation: 0 },
            { id: "4", x: 814, y: 186, width: 319, height: 456, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-04-h3v1-06",
        name: "PO 06 - H3V1",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-04-h3_v1_06.png",
        size: [1298, 827],
        style: {},
        slots: [
            { id: "1", x: 54, y: 168, width: 542, height: 325, rotation: 0, imageRotation: 0 },         
            { id: "2", x: 54, y: 501, width: 267, height: 173, rotation: 0, imageRotation: 0 },
            { id: "3", x: 329, y: 501, width: 266, height: 173, rotation: 0, imageRotation: 0 },
            { id: "4", x: 650, y: 0, width: 648, height: 827, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-04-h3v1-07",
        name: "PO 07 - H3V1",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-04-h3_v1_07.png",
        size: [1298, 827],
        style: {},
        slots: [
            { id: "1", x: 77, y: 59, width: 496, height: 710, rotation: 0, imageRotation: 0 },
            { id: "2", x: 732, y: 351, width: 483, height: 290, rotation: 0, imageRotation: 0 },
            { id: "3", x: 732, y: 185, width: 238, height: 158, rotation: 0, imageRotation: 0 },
            { id: "4", x: 978, y: 185, width: 237, height: 158, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-04-h3v1-08",
        name: "PO 08 - H3V1",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-04-h3_v1_08.png",
        size: [1298, 827],
        style: {},
        slots: [
            { id: "1", x: 0, y: 176, width: 318, height: 233, rotation: 0, imageRotation: 0 },
            { id: "2", x: 0, y: 417, width: 318, height: 233, rotation: 0, imageRotation: 0 },
            { id: "3", x: 326, y: 176, width: 644, height: 474, rotation: 0, imageRotation: 0 },
            { id: "4", x: 978, y: 176, width: 320, height: 474, rotation: 0, imageRotation: 0 }           
        ],
    },

    {
        id: "po-04-h3v1-09",
        name: "PO 09 - H3V1",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-04-h3_v1_09.png",
        size: [1298, 827],
        style: {},
        slots: [
            { id: "1", x: 54, y: 57, width: 471, height: 714, rotation: 0, imageRotation: 0 },
            { id: "2", x: 533, y: 57, width: 712, height: 485, rotation: 0, imageRotation: 0 },
            { id: "3", x: 533, y: 550, width: 352, height: 221, rotation: 0, imageRotation: 0 },
            { id: "4", x: 893, y: 550, width: 352, height: 221, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-04-h3v1-10",
        name: "PO 10 - H3V1",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-04-h3_v1_10.png",
        size: [1298, 827],
        style: {},
        slots: [
            { id: "1", x: 198, y: 78, width: 280, height: 380, rotation: 0, imageRotation: 0 },
            { id: "2", x: 486, y: 78, width: 613, height: 380, rotation: 0, imageRotation: 0 },
            { id: "3", x: 198, y: 466, width: 447, height: 285, rotation: 0, imageRotation: 0 },
            { id: "4", x: 653, y: 466, width: 447, height: 285, rotation: 0, imageRotation: 0 }
        ],
    }
];